import React from 'react'
import Fragment from '../common/fragment'


function FragmentBE(props) {
  return (
    <Fragment pos="ee" {...props}>
      <p>
“Estaba predestinado a mi labor: desde mi más pequeña infancia siempre he tenido
alguna red que tramar.” (Deligny)
      </p>
    </Fragment>
  )
}


export default FragmentBE
